import moment from 'moment'
import { Local } from './storage'
import { i18n } from '../i18n'
/**
 * 时间日期转换
 * @param date 当前时间，new Date() 格式
 * @param format 需要转换的时间格式字符串
 * @description format 字符串随意，如 `YYYY-mm、YYYY-mm-dd`
 * @description format 季度："YYYY-mm-dd HH:MM:SS QQQQ"
 * @description format 星期："YYYY-mm-dd HH:MM:SS WWW"
 * @description format 几周："YYYY-mm-dd HH:MM:SS ZZZ"
 * @description format 季度 + 星期 + 几周："YYYY-mm-dd HH:MM:SS WWW QQQQ ZZZ"
 * @returns 返回拼接后的时间字符串
 */
type Format =
	| 'YYYY-mm'
	| 'HH:MM:SS'
	| 'YYYY-mm-dd'
	| 'YYYY-mm-dd HH:MM:SS'
	| 'YYYY-mm-dd HH:MM:SS QQQQ'
	| 'YYYY-mm-dd HH:MM:SS WWW'
	| 'YYYY-mm-dd HH:MM:SS ZZZ'
	| 'YYYY-mm-dd HH:MM:SS WWW QQQQ ZZZ'
	| 'YYYY.mm'
	| 'YYYY.mm.dd'
	| 'YYYY.mm.dd HH:MM:SS'
	| 'YYYY.mm.dd HH:MM:SS QQQQ'
	| 'YYYY.mm.dd HH:MM:SS WWW'
	| 'YYYY.mm.dd HH:MM:SS ZZZ'
	| 'YYYY.mm.dd HH:MM:SS WWW QQQQ ZZZ'
	| 'YYYYmmdd'
export function formatDate1(date: Date, format: Format): string {
	const { t } = i18n.global
	let we = date.getDay() // 星期
	let z = getWeek(date) // 周
	let qut = Math.floor((date.getMonth() + 3) / 3).toString() // 季度
	const opt: { [key: string]: string } = {
		'Y+': date.getFullYear().toString(), // 年
		'm+': (date.getMonth() + 1).toString(), // 月(月份从0开始，要+1)
		'd+': date.getDate().toString(), // 日
		'H+': date.getHours().toString(), // 时
		'M+': date.getMinutes().toString(), // 分
		'S+': date.getSeconds().toString(), // 秒
		'q+': qut, // 季度
	}
	// 中文数字 (星期)
	const week: { [key: string]: string } = {
		'0': t('utils.day'),
		'1': t('utils.one'),
		'2': t('utils.two'),
		'3': t('utils.three'),
		'4': t('utils.four'),
		'5': t('utils.five'),
		'6': t('utils.six'),
	}
	// 中文数字（季度）
	const quarter: { [key: string]: string } = {
		'1': t('utils.one'),
		'2': t('utils.two'),
		'3': t('utils.three'),
		'4': t('utils.four'),
	}
	if (/(W+)/.test(format))
		format = <Format>(
			format.replace(
				RegExp.$1,
				RegExp.$1.length > 1
					? RegExp.$1.length > 2
						? t('utils.week1') + week[we]
						: t('utils.week2') + week[we]
					: week[we]
			)
		)
	if (/(Q+)/.test(format))
		format = <Format>(
			format.replace(
				RegExp.$1,
				RegExp.$1.length == 4 ? t('utils.no') + quarter[qut] + t('utils.the_quarter') : quarter[qut]
			)
		)
	if (/(Z+)/.test(format))
		format = <Format>(
			format.replace(
				RegExp.$1,
				RegExp.$1.length == 3 ? t('utils.no') + z + t('utils.week2') : z + ''
			)
		)
	for (let k in opt) {
		let r = new RegExp('(' + k + ')').exec(format)
		// 若输入的长度不为1，则前面补零
		if (r)
			format = <Format>(
				format.replace(
					r[1],
					RegExp.$1.length == 1 ? opt[k] : opt[k].padStart(RegExp.$1.length, '0')
				)
			)
	}
	return format
}
export function formatDate(isostr: number | Date | string, format: Format = 'YYYY-mm-dd HH:MM:SS') {
	if (!isostr) {
		return ''
	}
	try {
		const userInfo = Local.get('account-font-userInfo')
		const sys_time = userInfo.storeInfo.time_zone
		const reg = RegExp(/-/) //这儿注意有坑。。如果包含了-则不需要处理如果包含了+需要加上-, 后端php无法处理这个问题所以这儿反向判断了。。
		const data = reg.test(sys_time)
			? Number(sys_time.split(/[-|+]/)[1])
			: -Number(sys_time.split(/[-|+]/)[1])
		const time = (isostr as number) * 1000
		const newData =
			((isNaN(data) ? 0 : data) - moment().parseZone().utcOffset() / 60) * 60 * 60 * 1000 + time
		return formatDate1(new Date(newData), format)
	} catch (error) {
		//这儿因为统一改过时间了以前用的formatDate1在页面new Date现在改了方式所以统一处理下异常
		return formatDate1(new Date(isostr), format)
	}
}
/**
 * 获取当前日期是第几周
 * @param dateTime 当前传入的日期值
 * @returns 返回第几周数字值
 */
export function getWeek(dateTime: Date): number {
	let temptTime = new Date(dateTime.getTime())
	// 周几
	let weekday = temptTime.getDay() || 7
	// 周1+5天=周六
	temptTime.setDate(temptTime.getDate() - weekday + 1 + 5)
	let firstDay = new Date(temptTime.getFullYear(), 0, 1)
	let dayOfWeek = firstDay.getDay()
	let spendDay = 1
	if (dayOfWeek != 0) spendDay = 7 - dayOfWeek + 1
	firstDay = new Date(temptTime.getFullYear(), 0, 1 + spendDay)
	let d = Math.ceil((temptTime.valueOf() - firstDay.valueOf()) / 86400000)
	let result = Math.ceil(d / 7)
	return result
}

/**
 * 将时间转换为 `几秒前`、`几分钟前`、`几小时前`、`几天前`
 * @param param 当前时间，new Date() 格式或者字符串时间格式
 * @param format 需要转换的时间格式字符串
 * @description param 10秒：  10 * 1000
 * @description param 1分：   60 * 1000
 * @description param 1小时： 60 * 60 * 1000
 * @description param 24小时：60 * 60 * 24 * 1000
 * @description param 3天：   60 * 60* 24 * 1000 * 3
 * @returns 返回拼接后的时间字符串
 */
export function formatPast(param: string | Date, format: Format = 'YYYY-mm-dd'): string {
	const { t: $t } = i18n.global
	// 传入格式处理、存储转换值
	let t: any, s: number
	// 获取js 时间戳
	let time: number = new Date().getTime()
	// 是否是对象
	typeof param === 'string' || 'object' ? (t = new Date(param).getTime()) : (t = param)
	// 当前时间戳 - 传入时间戳
	time = Number.parseInt(`${time - t}`)
	if (time < 10000) {
		// 10秒内
		return $t('utils.just')
	} else if (time < 60000 && time >= 10000) {
		// 超过10秒少于1分钟内
		s = Math.floor(time / 1000)
		return `${s}${$t('utils.seconds_ago')}`
	} else if (time < 3600000 && time >= 60000) {
		// 超过1分钟少于1小时
		s = Math.floor(time / 60000)
		return `${s}${$t('utils.mintues_ago')}`
	} else if (time < 86400000 && time >= 3600000) {
		// 超过1小时少于24小时
		s = Math.floor(time / 3600000)
		return `${s}${$t('utils.hours_ago')}`
	} else if (time < 259200000 && time >= 86400000) {
		// 超过1天少于3天内
		s = Math.floor(time / 86400000)
		return `${s}${$t('utils.days_ago')}`
	} else {
		// 超过3天
		let date = typeof param === 'string' || 'object' ? new Date(param) : param
		return formatDate(date, format) as string
	}
}

/**
 * 时间问候语
 * @param param 当前时间，new Date() 格式
 * @description param 调用 `formatAxis(new Date())` 输出 `上午好`
 * @returns 返回拼接后的时间字符串
 */
export function formatAxis(param: Date): string {
	const { t } = i18n.global
	let hour: number = new Date(param).getHours()
	if (hour < 6) return t('utils.greeting_axis1')
	else if (hour < 9) return t('utils.greeting_axis2')
	else if (hour < 12) return t('utils.greeting_axis3')
	else if (hour < 14) return t('utils.greeting_axis4')
	else if (hour < 17) return t('utils.greeting_axis5')
	else if (hour < 19) return t('utils.greeting_axis6')
	else if (hour < 22) return t('utils.greeting_axis7')
	else return t('utils.greeting_axis8')
}

/**
 * 根据后端返回时区获取对应时区
 */
export function getGmtTime(format: Format = 'YYYY-mm-dd HH:MM:SS') {
	const userInfo = Local.get('account-font-userInfo')
	const sys_time = userInfo.storeInfo.time_zone
	const reg = RegExp(/-/) //这儿注意有坑。。如果包含了-则不需要处理如果包含了+需要加上-, 后端php无法处理这个问题所以这儿反向判断了。。
	const data = reg.test(sys_time)
		? Number(sys_time.split(/[-|+]/)[1])
		: -Number(sys_time.split(/[-|+]/)[1])
	const time = new Date().getTime()
	const newData =
		((isNaN(data) ? 0 : data) - moment().parseZone().utcOffset() / 60) * 60 * 60 * 1000 + time
	return formatDate1(new Date(newData), format)
}
/**
 * 设置提示时区文字
 */
export function gmtTimeText() {
	// const timeZone = useStore().state.userInfos.userInfos.storeInfo.gmt_time_zone
	// const timeZoneTxt = timeZone ? `(${timeZone})` : ''
	// return ` <span class='time_zone'> ${timeZoneTxt} </span> <a href="/admin/setting/system/basic" class="set_time">设置时区</a>`
}
//获取当前月的第一天
export function getMonthFirstDay() {
	let data = new Date()
	data.setDate(1)
	data.setHours(0)
	data.setSeconds(0)
	data.setMinutes(0)
	return new Date(data.getTime())
}
